import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import { MultiStepContext } from './multiStepContext';

const Wrapper = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [reachedSteps, setReachedSteps] = useState([]);
  const [stepsValidity, setStepsValidity] = useState([]);

  const handleChangeStep = step => {
    setCurrentStep(step);
  };

  // Handling updating reached steps
  const handleSetReachedSteps = useCallback(
    stepIndex => {
      setReachedSteps(prev => {
        const current = [...prev];

        current[stepIndex] = true;

        return current;
      });
    },
    [setReachedSteps],
  );

  // Handling updating steps validity
  const handleChangeStepsValidity = useCallback(
    (stepIndex, stepValidity) => {
      setStepsValidity(prev => {
        const current = [...prev];

        current[stepIndex] = stepValidity;

        return current;
      });
    },
    [setStepsValidity],
  );

  useEffect(() => {
    handleSetReachedSteps(currentStep);
  }, [currentStep]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  return (
    <MultiStepContext.Provider
      value={{
        currentStep,
        next: () => handleChangeStep(currentStep + 1),
        handleChangeStep,
        reachedSteps,
        stepsValidity,
        handleSetReachedSteps,
        handleChangeStepsValidity,
      }}
    >
      {children}
    </MultiStepContext.Provider>
  );
};

Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Wrapper;
